import {
  ProjectCard,
  ProjectsGridFilterType
} from '../../components/PashaLanding/types';
import { LandingBrandPlacementListingTypeEnum } from '../../graphql/types';

export function filterProjectsGridItems(
  items: ProjectCard[],
  filter: ProjectsGridFilterType
): ProjectCard[] {
  if (filter === 'ALL') return items;
  return items.filter(
    item =>
      (filter === LandingBrandPlacementListingTypeEnum.Sale && item.forSale) ||
      (filter === LandingBrandPlacementListingTypeEnum.Rent && item.forRent)
  );
}
